import axios from 'axios';
import { queryCache, useMutation } from 'react-query';

const deleteSet = ({ setId }) => {
  return axios.delete(`/api/v3/sets/${setId}`);
};

const useDeleteSet = () => {
  return useMutation(deleteSet, {
    onSuccess: () => {
      // Invalidate all sets queries to ensure table updates
      queryCache.invalidateQueries(['sets']);
    },
    onError: (error: any) => {
      console.error(`ERROR! ${error}`);
    }
  });
};

// Bulk delete function that only invalidates once after all deletes complete
export const bulkDeleteSets = async (setIds: string[]): Promise<void> => {
  await Promise.all(setIds.map((setId) => axios.delete(`/api/v3/sets/${setId}`)));
  queryCache.invalidateQueries(['sets']);
};

export default useDeleteSet;